import {
  IEditVasRulePayload,
  IVasRuleCreate,
  IVasRuleDetails,
  IVasRuleListItem,
  IVasRuleListSearch,
} from "../../../types/master/vasRuleInterface";
import { VasRuleActionTypes, VasRuleActions } from "../../actionTypes/master/vasRuleActionTypes";

export const createVasRule = (payload: IVasRuleCreate): VasRuleActionTypes => ({
  type: VasRuleActions.CREATE_VAS_RULE,
  payload,
});

export const getVasRuleList = (payload: IVasRuleListSearch): VasRuleActionTypes => ({
  type: VasRuleActions.GET_VAS_RULE_LIST,
  payload,
});

export const setVasRuleList = (vasRuleList: Array<IVasRuleListItem>): VasRuleActionTypes => ({
  type: VasRuleActions.SET_VAS_RULE_LIST,
  payload: vasRuleList,
});

export const setVasRuleListPageCount = (payload: number): VasRuleActionTypes => ({
  type: VasRuleActions.SET_VAS_RULE_LIST_PAGE_COUNT,
  payload,
});

export const getVasRuleDataById = (id: number | string): VasRuleActionTypes => ({
  type: VasRuleActions.GET_VAS_RULE_DATA_BY_ID,
  payload: id,
});

export const setVasRuleDataById = (payload: IVasRuleDetails): VasRuleActionTypes => ({
  type: VasRuleActions.SET_VAS_RULE_DATA_BY_ID,
  payload,
});

export const editVasRule = (payload: IEditVasRulePayload): VasRuleActionTypes => ({
  type: VasRuleActions.EDIT_VAS_RULE_DATA_BY_ID,
  payload,
});
